import ConfirmationModal from "library/Molecules/Modal/ConfirmationModal";
import { PropTypes } from "prop-types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const ConfirmResetOrderModal = ({ onConfirm, onDecline, onClose, isLeavePage }) => {
  const { t } = useTranslation();

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onClose, onConfirm]);

  const handleDecline = useCallback(() => {
    onDecline();
    onClose();
  }, [onClose, onDecline]);

  return (
    <ConfirmationModal
      id="reset-new-order-form-modal"
      title={isLeavePage ? t("newOrder.modals.resetOrderModal.title") : t("common.modals.confirmModal.title")}
      description={
        isLeavePage ? t("newOrder.modals.resetOrderModal.description") : t("common.modals.confirmModal.description")
      }
      onConfirm={handleConfirm}
      onDecline={handleDecline}
      declineBtnText={t("common.buttons.backToBtn", { context: "order" })}
      confirmBtnText={
        isLeavePage ? t("newOrder.modals.resetOrderModal.leaveBtn") : t("newOrder.modals.resetOrderModal.resetOrderBtn")
      }
    />
  );
};

ConfirmResetOrderModal.defaultProps = {
  isLeavePage: false,
};

ConfirmResetOrderModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isLeavePage: PropTypes.bool,
};

export default ConfirmResetOrderModal;
